// Default values for store configuration
const STORE_DEFAULTS = {
  UPLOAD_BUCKET_IDX: 1,
  CLOUD_INFERENCE: {
    UPLOAD_BUCKET: "veesion-alerts-global-eu-central-1",
  },
};

export default STORE_DEFAULTS;
